import React from "react";
import { Link } from "react-router-dom";

const footerLinkGroups = [
  {
    id: "candidates",
    title: "For Candidates",
    links: [
      { id: "browse-jobs", label: "Browse Jobs", path: "/jobs" },
      { id: "dashboard", label: "Candidate Dashboard", path: "/candidate-dashboard" },
      { id: "job-alerts", label: "Job Alerts", path: "/candidate-job-alerts" },
      { id: "bookmarks", label: "Shortlisted Jobs", path: "/candidate-shortlisted-jobs" },
    ],
  },
  {
    id: "employers",
    title: "Employer / Recruiter",
    links: [
      { id: "signup", label: "Create Account", path: "/signup" },
      { id: "login", label: "Login", path: "/login" },
      { id: "dashboard", label: "Employer Dashboard", path: "/employee-dashboard" },
      { id: "post-job", label: "Post Job", path: "/employee-post-job" },
      { id: "manage-jobs", label: "Manage Jobs", path: "/employee-manage-jobs" },
      { id: "search-resumes", label: "Search Resumes / CVs - Coming Soon", path: "#" },
      { id: "pricing", label: "Pricing", path: "/pricing" },
    ],
  },
  {
    id: "company",
    title: "About Us",
    links: [
      { id: "about", label: "About", path: "/about" },
      { id: "jobs", label: "Job Page", path: "/jobs" },
      { id: "companies", label: "Companies", path: "/companies" },
      { id: "contact", label: "Contact", path: "/contact" },
    ],
  },
  {
    id: "resources",
    title: "Helpful Resources",
    links: [
      { id: "admin", label: "Admin Dashboard", path: "/admin-dashboard" },
      { id: "terms", label: "Terms of Use", path: "/terms" },
      { id: "privacy", label: "Privacy Center", path: "/privacy" },
    ],
  },
];

const socialLinks = [
  { id: "facebook", label: "Facebook", icon: "fab fa-facebook-f", path: "#" },
  { id: "twitter", label: "Twitter", icon: "fab fa-twitter", path: "#" },
  { id: "instagram", label: "Instagram", icon: "fab fa-instagram", path: "#" },
  { id: "linkedin", label: "LinkedIn", icon: "fab fa-linkedin-in", path: "#" },
];

const Footer = () => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  };

  return (
    <footer className="main-footer">
      <div className="auto-container">
        <div className="widgets-section wow fadeInUp">
          <div className="row">
            <div className="big-column col-xl-4 col-lg-3 col-md-12">
              <div className="footer-column about-widget">
                <div className="logo"><Link to="/" onClick={scrollToTop}><img src="logo-main.png" alt="Epic-Jobs" /></Link></div>
                <p className="phone-num"><span>Call us </span><a href="tel:8327953431">832.795.3431</a></p>
                <p className="address"><a href="mailto:Support@Epic-Jobs.com" className="email">Support@Epic-Jobs.com</a></p>
              </div>
            </div>

            <div className="big-column col-xl-8 col-lg-9 col-md-12">
              <div className="row">
                {footerLinkGroups.map((group) => (
                  <div className="footer-column col-lg-3 col-md-6 col-sm-12" key={group.id}>
                    <div className="footer-widget links-widget">
                      <h4 className="widget-title">{group.title}</h4>
                      <div className="widget-content">
                        <ul className="list">
                          {group.links.map((item) => (
                            <li key={item.id}>
                              {item.path === "#" ? <span className="footer-disabled-link">{item.label}</span> : <Link to={item.path} onClick={scrollToTop}>{item.label}</Link>}
                            </li>
                          ))}
                        </ul>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <div className="auto-container">
          <div className="outer-box">
            <div className="copyright-text">Copyright 2026 <Link to="/" onClick={scrollToTop}>Epic-Jobs</Link>. All Right Reserved.</div>
            <div className="social-links">
              {socialLinks.map((item) => (
                <a href={item.path} aria-label={item.label} key={item.id}>
                  <i className={item.icon}></i>
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>

      <div className="scroll-to-top scroll-to-target" data-target="html"><span className="fa fa-angle-up"></span></div>
    </footer>
  );
};

export default Footer;
